import React from 'react'
import { Link } from 'gatsby'
import { colors, alpha, s } from '../style'

const Button = ({
  children,
  action,
  link,
  glow,
  trade,
  dimmed,
  dimmedWhite,
  reactive,
  reactiveBlack,
  shadow,
  active,
  w100,
  extraCss,
  small,
  noMargin,
  googleId,
  dataFormType,
  disabled
}) => {
  const style = glow
    ? 'glow'
    : trade 
    ? 'trade'
    : dimmed
    ? 'dimmed'
    : shadow
    ? 'shadow'
    : reactive
    ? 'reactive'
    : reactiveBlack
    ? 'reactiveBlack'
    : dimmedWhite
    ? 'dimmedWhite'
    : 'default'

  const switchStyle = () => {
    switch (style) {
      case 'glow':
        return sButtonGlow
      case 'trade':
        return sButtonTrade
      case 'dimmed':
        return sButtonDimmed
      case 'dimmedWhite':
        return sButtonDimmedWhite
      case 'reactive':
        return sButtonReactive(active)
      case 'reactiveBlack':
        return sButtonReactiveBlack(active)
      case 'shadow':
        return sButtonShadow
      default:
        return sButtonReactive(false)
    }
  }
  const styleArray = [
    sButton,
    switchStyle,
    w100 && { width: '100%' },
    extraCss,
    small && sSmall,
    noMargin && { marginBottom: 0 }, 
  ]


  if (action)
    return (
      <button
        onClick={action}
        css={styleArray}
        name='btn'
        id={googleId}
        data-formtype={dataFormType}
        disbaled={disabled ? true : false}
      >
        {children}
      </button>
    )

  if (!action && !link) return <button name='btn'>{children}</button>

  return link.includes('https://') ? (
    <a href={link} target='_blank' rel='noreferrer noopener' css={styleArray}>
      {children}
    </a>
  ) : (
    <Link to={link} css={styleArray}>
      {children}
    </Link>
  )
}

export const sButton = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  textAlign: 'center',
  marginBottom: '2rem',
  [s.xs]: {
    width: '100%',
  },
  '&:focus': {
    filter: 'brightness(75%) contract(2)',
    transform: 'scale(1.1)',
  },
}

export const sButtonGlow = {
  transition: 'all 0.2s ease-out',
  width: 'max-content',
  fontSize: '0.875rem', // was 1rem
  letterSpacing: '0rem',
  background: `linear-gradient(to bottom right, ${colors.brandDark}, ${colors.brandLight})`,
  padding: '1rem 3rem',
  boxShadow: `0px 0px 32px #2b2c69`,
  textTransform: 'uppercase',
  fontWeight: 700,
  borderRadius: '2rem',
  color: colors.white,

  '&:hover': {
    filter: 'brightness(125%)',
    boxShadow: `0px 0px 16px #2b2c69`,
  },
}

export const sButtonTrade = {
  transition: 'all 0.2s ease-out',
  width: 'max-content',
  fontSize: '0.875rem', // was 1rem
  letterSpacing: '0rem',
  background: `linear-gradient(to bottom right, ${colors.brandDark}, ${colors.brandLight})`,
  padding: '1rem 3rem',
  boxShadow: `0px 0px 32px #5253b8`,
  textTransform: 'uppercase',
  fontWeight: 700,
  borderRadius: '2rem',
  color: colors.white,
  [s.xs]: {
    width: 'auto',
  },

  '&:hover': {
    filter: 'brightness(125%)',
    boxShadow: `0px 0px 16px #5253b8`,
  },
}

const sButtonDimmed = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  transition: 'all 0.2s ease-out',
  fontSize: '0.875rem',
  backgroundColor: colors.white.concat(alpha[8]),
  padding: '15px 2rem 14px',
  textTransform: 'uppercase',
  fontWeight: 700,
  borderRadius: '2rem',
  textAlign: 'center',
  // letterSpacing: '0.2em',
  color: colors.white.concat(alpha[30]),

  '&:hover': {
    [s.hover]: {
      color: colors.white.concat(alpha[100]),
      // letterSpacing: '0.4em',
      backgroundColor: colors.white.concat(alpha[16]),
    },
  },
}

const sButtonDimmedWhite = {
  ...sButtonDimmed,
  backgroundColor: colors.white.concat(alpha[16]),
  color: colors.white.concat(alpha[60]),
  [s.sm]: {
    backdropFilter: 'blur(8px)',
  },
  '&:hover': {
    [s.hover]: {
      color: colors.white.concat(alpha[100]),
      backgroundColor: colors.white.concat(alpha[30]),
    },
  },
  '&:focus': {
    transform: 'scale(1)',
  },
}

const sButtonShadow = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  transition: 'all 0.2s ease-out',
  fontSize: '0.875rem',
  backgroundColor: colors.white,
  padding: '15px 2rem 14px',
  textTransform: 'uppercase',
  fontWeight: 800,
  borderRadius: '2rem',
  // letterSpacing: '0.2em',
  textAlign: 'center',
  color: colors.greyDarker.concat(alpha[80]),
  boxShadow: `0px 0px 24px ${colors.greyDarker.concat(alpha[16])}`,

  '&:hover': {
    [s.hover]: {
      color: colors.greyDarker,
      boxShadow: `0px 16px 32px ${colors.greyDarker.concat(alpha[8])}`,
    },
  },
}

const sButtonReactive = (active) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  transition: 'all 0.2s ease-out',
  fontSize: '0.875rem',
  padding: '15px 2rem 14px',
  textTransform: 'uppercase',
  fontWeight: 700,
  borderRadius: '2rem',
  // letterSpacing: '0.2em',
  textAlign: 'center',

  backgroundColor: active
    ? colors.brand.concat(alpha[16])
    : colors.greyDarker.concat(alpha[8]),
  color: active
    ? colors.brandDark.concat(alpha[80])
    : colors.greyDarker.concat(alpha[30]),

  '&:hover': {
    backgroundColor: active
      ? colors.brand.concat(alpha[30])
      : colors.greyDarker.concat(alpha[16]),
    color: active ? colors.brandDark : colors.greyDarker,
    filter: active ? 'brightness(120%)' : 'brightness(100%)',
  },
})

const sButtonReactiveBlack = (active) => ({
  ...sButtonReactive(),
  backgroundColor: active ? colors.text : colors.greyLighter,
  color: active ? colors.white : colors.greyDarker.concat(alpha[30]),

  '&:hover': {
    backgroundColor: active ? colors.text : colors.greyLight,
    color: active ? colors.white : colors.greyDarker,
    filter: active ? 'brightness(150%)' : 'brightness(100%)',
  },
})

const sSmall = {
  fontSize: '0.75rem',
  padding: '0.75rem 1rem',
}

export default Button
